module.exports = __webpack_public_path__ + "primeicons.b8eccb1059ea5faaf6d8.eot";


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/node_modules/primeicons/fonts/primeicons.eot
// module id = ../../../../primeicons/fonts/primeicons.eot
// module chunks = styles